import { defineMessage } from "react-intl";

export const SUBSCRIPTIONS_SORT_VALUE_DATE_ASC = "created_asc";
export const SUBSCRIPTIONS_SORT_VALUE_DATE_DESC = "created_desc";

export const SUBSCRIPTIONS_SORTS = {
  [SUBSCRIPTIONS_SORT_VALUE_DATE_ASC]: {
    value: SUBSCRIPTIONS_SORT_VALUE_DATE_ASC,
    message: defineMessage({ defaultMessage: "Date de création croissante" }),
  },
  [SUBSCRIPTIONS_SORT_VALUE_DATE_DESC]: {
    value: SUBSCRIPTIONS_SORT_VALUE_DATE_DESC,
    message: defineMessage({ defaultMessage: "Date de création décroissante" }),
  },
};

export const SUBSCRIPTIONS_SORT_LIST = Object.values(SUBSCRIPTIONS_SORTS);

// ============================================================

export const SUBSCRIPTIONS_TYPES_VALUE_PER_HOLDER = "per_holder";
export const SUBSCRIPTIONS_TYPES_VALUE_PER_CUSTOMER = "per_customer";

/**
 * @type {{[key: string]: {
 * value: string,
 * label: import("react-intl").MessageDescriptor,
 * description: import("react-intl").MessageDescriptor,
 * }}}
 */
export const SUBSCRIPTIONS_TYPES = {
  [SUBSCRIPTIONS_TYPES_VALUE_PER_HOLDER]: {
    value: SUBSCRIPTIONS_TYPES_VALUE_PER_HOLDER,
    label: defineMessage({ defaultMessage: "Adhérent" }),
    description: defineMessage({
      defaultMessage: "Cotisation par adhérent",
    }),
  },
  [SUBSCRIPTIONS_TYPES_VALUE_PER_CUSTOMER]: {
    value: SUBSCRIPTIONS_TYPES_VALUE_PER_CUSTOMER,
    label: defineMessage({ defaultMessage: "Foyer" }),
    description: defineMessage({
      defaultMessage: "Cotisation par foyer",
    }),
  },
};

export const SUBSCRIPTIONS_TYPES_LIST = Object.values(SUBSCRIPTIONS_TYPES);
